import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing p-20" }
const _hoisted_4 = { key: 1 }

import { ref, onMounted } from 'vue'
import PassContent from "../../components/Common/PassContent.vue"
import { useRoute } from 'vue-router'
import { reportCompanyService } from '@/api/reportCompanyService'

interface Company {
  id: string
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplyPage',
  setup(__props) {

const route = useRoute()
const company = ref<Company | null>(null)
const emailAddress = ref('')
const recipientName = ref('')
const isActionsEnabled = ref(false)

const fetchCompanyData = async () => {
  try {

    let companyName = route.query.company_name || false;
    let companyWebsite = route.query.company_website || false;

    company.value = {
        id: 0,
        name: ''
    }

    if ( companyName && companyWebsite ) {
        
        let responseCompany = await reportCompanyService.getOrMakeCompany(companyName, companyWebsite);

        isActionsEnabled.value = responseCompany.will_use_status_feature

        company.value.id = responseCompany.id
        company.value.name = responseCompany.name
        recipientName.value = responseCompany.inbound_reply_to_name
        emailAddress.value = responseCompany.inbound_reply_to_email

    }

  } catch (error) {
    console.error('Failed to fetch company data:', error)
  }
}

const handleUpdateStatus = (status: string) => {
  // Implement status update logic
}

onMounted(() => {
  fetchCompanyData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (company.value)
          ? (_openBlock(), _createBlock(PassContent, {
              key: 0,
              "company-id": company.value.id,
              "company-name": company.value.name,
              "email-address": emailAddress.value,
              "recipient-name": recipientName.value,
              "is-actions-enabled": isActionsEnabled.value,
              onUpdateStatus: handleUpdateStatus
            }, null, 8, ["company-id", "company-name", "email-address", "recipient-name", "is-actions-enabled"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
      ])
    ])
  ]))
}
}

})